import { TrackingInfo as TrackingInfoMyAccountArea } from "./TrackingInfoMyAccountArea";
import { PageContextUtils } from "../../utils";

//TODO: When old user area is replaced by MyAccountArea, delete this file and replace TrackingInfoUserArea by TrackingInfoMyAccountArea in all files
const { myAccountAreaComponents } = PageContextUtils.getVisualData();

export const TrackingInfo = myAccountAreaComponents
  ? TrackingInfoMyAccountArea
  : {
      dataCategory: "User Area",
      dataAction: "click",
      dataLabel: ""
    };
